import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const types = {
  SET_WEBCONFIG: 'SET_WEBCONFIG',
  SET_PLATES: 'SET_PLATES'
}

const state = { // 需要维护的状态
  webConfigs: null,
  plates: []
}
const getters = {
  isShow: state => {
    return state.plates.length && state.webConfigs
  },
  logopic: state => state.webConfigs.logopic,
  copyright: state => state.webConfigs.copyright,
  recodenum: state => state.webConfigs.recodenum,
  address: state => state.webConfigs.address
}
const mutations = {
  [types.SET_WEBCONFIG](state, data) {
    console.log("SET_WEBCONFIG", data);
    state.webConfigs = data;
  },
  [types.SET_PLATES](state, data) {
    console.log("SET_PLATES", data);
    state.plates = data;
  }
}

const actions = {
  [types.SET_WEBCONFIG]({ commit }, data) {
    localStorage.setItem('sealpicsrc', data.sealpicsrc);
    commit(types.SET_WEBCONFIG, data)
  },
  [types.SET_PLATES]({ commit }, data) {
    commit(types.SET_PLATES, data)
  }
}

export default new Vuex.Store({
  state,
  getters,
  mutations,
  actions
})
